import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PreorderListModel} from '../../../../shared/services/preorder/preorderList.model';
import {WebchargeListModel} from '../../../../shared/services/webcharge/webchargeList.model';

@Component({
  selector: 'app-webcharge-overview-table',
  templateUrl: './webcharge-overview-table.component.html',
  styleUrls: ['./webcharge-overview-table.component.scss']
})
export class WebchargeOverviewTableComponent {
  @Input() webcharges: WebchargeListModel[];

  @Output() openDetails = new EventEmitter<string>();

  constructor() { }

  onOpenDetails(reference: string) {
    this.openDetails.emit(reference);
  }
}
